import { useEffect } from "react";
import { Grid } from "@mui/material";
import { SiteHeader } from "../../containers/SiteHeader/SiteHeader";
import { Footer } from "../../containers/Footer/Footer";
import { HeroSection } from "./sections/HeroSection";
import { JobsSection } from "./sections/JobsSection";
import { AchievementsSection } from "./sections/AchievementsSection";
import { GrowthSection } from "./sections/GrowthSection";
import { CareerPathSection } from "./sections/CareerPathSection";
import { EnvironmentSection } from "./sections/EnvironmentSection";
import { GuildSection } from "./sections/GuildSection";
import { VoicesSection } from "./sections/VoicesSection";
import { RequirementsSection } from "./sections/RequirementsSection";
import { CTASection } from "./sections/CTASection";
import { FloatingCTA } from "./components/FloatingCTA";

export const RecruitPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Grid container direction="column" sx={{ width: "100%", overflowX: "hidden" }}>
      <SiteHeader />
      <HeroSection />
      <JobsSection />
      <AchievementsSection />
      <GrowthSection />
      <CareerPathSection />
      <EnvironmentSection />
      <GuildSection />
      <VoicesSection />
      <RequirementsSection />
      <CTASection />
      <Footer />
      <FloatingCTA />
    </Grid>
  );
};
